import React from 'react';
import PropTypes from 'prop-types';
import { FormattedMessage } from 'react-intl';
import s from './LoadingSpinner.module.scss';
// from http://tobiasahlin.com/spinkit/

/** A loading spinner for indicating loading states */
function LoadingSpinner(props) {
  const { color } = props;
  const classNames = `${s.skCircle} ${s[color]}`;
  return (
    <>
      <div className={s.altText}>
        <FormattedMessage id="loading" />
      </div>
      <div className={classNames}>
        <div className={`${s.skChild}`} />
        <div className={`${s.skCircle2} ${s.skChild}`} />
        <div className={`${s.skCircle3} ${s.skChild}`} />
        <div className={`${s.skCircle4} ${s.skChild}`} />
        <div className={`${s.skCircle5} ${s.skChild}`} />
        <div className={`${s.skCircle6} ${s.skChild}`} />
        <div className={`${s.skCircle7} ${s.skChild}`} />
        <div className={`${s.skCircle8} ${s.skChild}`} />
        <div className={`${s.skCircle9} ${s.skChild}`} />
        <div className={`${s.skCircle10} ${s.skChild}`} />
        <div className={`${s.skCircle11} ${s.skChild}`} />
        <div className={`${s.skCircle12} ${s.skChild}`} />
      </div>
    </>
  );
}

LoadingSpinner.propTypes = {
  /** Color variant of the spinner */
  color: PropTypes.oneOf(['white', 'grey', 'turquoise']).isRequired,
};

export default LoadingSpinner;
